/**
 * Sponsor Request Styles
 */

import styled, { css } from 'styled-components';

export const Container = styled.div`
  padding: 24px;
  max-width: 900px;
  margin: 0 auto;
  min-height: 80vh;
`;

export const Header = styled.div`
  margin-bottom: 32px;
  text-align: center;
`;

export const Title = styled.h1`
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 8px;
  color: ${({ theme }) => theme.text?.primary || '#fff'};
`;

export const ProgressSection = styled.div`
  margin-bottom: 40px;
`;

export const StepsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 600px;
  margin: 0 auto;
`;

export const StepLabel = styled.div<{ active: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  flex: 1;

  ${({ active, theme }) =>
    active &&
    css`
      color: ${theme.primary || '#FFC700'};
    `}
`;

export const StepNumber = styled.div<{ active: boolean }>`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 18px;
  border: 2px solid ${({ theme }) => theme.text?.secondary || '#888'};
  color: ${({ theme }) => theme.text?.secondary || '#888'};
  background: transparent;
  transition: all 0.3s ease;

  ${({ active, theme }) =>
    active &&
    css`
      border-color: ${theme.primary || '#FFC700'};
      color: ${theme.primary || '#FFC700'};
      background: ${theme.primary ? `${theme.primary}20` : 'rgba(255, 199, 0, 0.2)'};
    `}
`;

export const ContentSection = styled.div`
  background: ${({ theme }) => theme.background?.secondary || 'rgba(255, 255, 255, 0.05)'};
  border-radius: 12px;
  padding: 32px;
  min-height: 400px;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid ${({ theme }) => theme.text?.secondary || 'rgba(255, 255, 255, 0.1)'};

  @media (max-width: 768px) {
    flex-direction: column-reverse;

    button {
      width: 100%;
    }
  }
`;

export const AvailabilitySection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 0;
`;

export const InfoBox = styled.div`
  background: ${({ theme }) => theme.background?.primary || 'rgba(0, 0, 0, 0.3)'};
  padding: 20px;
  border-radius: 8px;
  border-left: 4px solid ${({ theme }) => theme.primary || '#FFC700'};
  margin-bottom: 24px;
  width: 100%;
  max-width: 600px;
`;
